
import React      from 'react';
import CSSModules from 'react-css-modules';

import classNames     from 'classnames/bind';
import stylingUtils   from '../../services/stylingUtilities';
import eventFormatter from '../../services/eventFormatter';
import costCalculator from '../../services/costCalculator';

import style from './style.scss';

class OrderSummary extends React.Component {

    constructor(params) {

        super(params);

        this._updateOrderSummaryPosition = this._updateOrderSummaryPosition.bind(this);

        this.state = {
            isOrderSummaryFixed: false
        };
    }

    componentDidMount() {

        window.addEventListener('scroll', this._updateOrderSummaryPosition);
    }

    componentWillUnmount() {

        window.removeEventListener('scroll', this._updateOrderSummaryPosition);
    }

    _updateOrderSummaryPosition() {

        const INITIAL_SUMMARY_POSITION = 180;

        // console.log('document.documentElement.scrollTop: ', document.documentElement.scrollTop);
        // console.log('isOrderSummaryFixed: ', this.state.isOrderSummaryFixed);

        if ((document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop > INITIAL_SUMMARY_POSITION) {

            this.setState({
                isOrderSummaryFixed: true
            });

        } else {

            this.setState({
                isOrderSummaryFixed: false
            });
        }
    }

    _getOrderSummaryClassName() {

        var cx = classNames.bind(style);

        var baseStyle = {
            'container': true,
            'container--fixed': this.state.isOrderSummaryFixed
        };

        return cx(stylingUtils.mergeClassNames(baseStyle, this.props.className));
    }

    _getCourse() {

        if (this.props.event) {
            return this.props.event.course.name;
        }

        if (this.props.eLearningCourse) {
            return this.props.eLearningCourse.name;
        }
    }

    _getModule() {

        if (this.props.event) {
            return this.props.event.course.module.name;
        }

        if (this.props.eLearningCourse) {
            return this.props.eLearningCourse.module.name;
        }
    }

    _getDateRange() {

        if (this.props.event) {

            const formattedEvent = eventFormatter.format(this.props.event);

            if (formattedEvent.multiple_days) {

                return formattedEvent.multiple_days_events.map(d => d.date_range);
            }

            return [formattedEvent.date_range];
        }
    }

    _getVenueAddress() {

        if (this.props.event) {

            const formattedEvent = eventFormatter.format(this.props.event);

            return formattedEvent.venue_address_text;
        }
    }

    _getDelegateQuantity() {

        var delegateType = '' ;

        if (this.props.sector === 'public') {

            delegateType = 'Public';

        } else if (this.props.sector === 'private') {

            delegateType = 'Private';
        }

        return this.props.attendees.length + ' x ' + delegateType + ' Delegates';
    }

    _getDelegatePrice() {
        if (this.props.event && this.props.event.overridden_price) {
            return this.props.event.overridden_price;
        } else if (this.props.eLearningCourse && this.props.eLearningCourse.overridden_price) {
            return this.props.eLearningCourse.overridden_price;
        }

        if (this.props.sector === 'public') {
            if (this.props.event) return this.props.event.public_price;
            if (this.props.eLearningCourse) return this.props.eLearningCourse.public_price;
        } else if (this.props.sector === 'private') {
            if (this.props.event) return this.props.event.private_price;
            if (this.props.eLearningCourse) return this.props.eLearningCourse.private_price;
        }

        return 0;
    }
    
    _getCostBreakdown() {

        const options = {
            is_elearning_course: !!this.props.eLearningCourse,
            course: this.props.event ? this.props.event.course : this.props.eLearningCourse,
            delegates: this.props.attendees,
            full_delegate_price: this._getDelegatePrice(),
            promotion_codes: this.props.promotions,
            include_vat: this.props.includeVAT
        };

        return costCalculator.calculate(options);
    }

    _getTotalVAT() {
        if (this.props.includeVAT) {
            return parseFloat(this._getCostBreakdown().total_vat).toFixed(2);
        } else {
            return parseFloat('0').toFixed(2);
        }
    }

    _getSubtotal() {

        return parseFloat(this._getCostBreakdown().subtotal).toFixed(2);
    }

    _getTotalExcVAT() {

        return parseFloat(this._getCostBreakdown().total_exc_vat).toFixed(2);
    }

    _getTotal() {

        return parseFloat(this._getCostBreakdown().total).toFixed(2);
    }

    _getPromotions() {

        return this._getCostBreakdown().promotions;
    }

    _getDelegateDiscountValue() {

        return parseFloat(this._getCostBreakdown().delegate_discount_value).toFixed(2);
    }

    _getDelegateCosts() {

        return this._getCostBreakdown().delegate_costs;
    }

    render() {

        const vatPercent = this.props.includeVAT ? '20' : '0';

        return (

            <article className={ this._getOrderSummaryClassName() }>

                <div className={style['order-summary-header']}>
                    <h2 styleName="panel-title">Summary of Costs</h2>

                    <div className={style['order-summary-header__section']}>
                        <strong>{ this._getModule() }</strong><br/>
                        <strong>{ this._getCourse() }</strong>
                    </div>

                    {this.props.event &&
                        <div>
                            <div className={style['order-summary-header__section']}>
                                {this._getDateRange().map((date, i) => {
                                    return <span key={i} className={style['event-date-line']}>{ date }</span>
                                })}
                            </div>

                            {this.props.event.course.type !== "webinar" && (
                                <div className={style['order-summary-header__section']}>
                                    { this._getVenueAddress() }
                                </div>
                            )}
                        </div>
                    }
                </div>

                <table className={style['order-summary-table']}>
                    <tbody>
                    {this._getDelegateCosts().map((delegate, i) => {
                        return (
                            <tr key={i}>
                                <td>{ delegate.first_name } { delegate.last_name } { !!this.props.eLearningCourse && delegate.unit_ids.length > 0 && <span>(Modules x { delegate.unit_ids.length })</span> }</td>
                                <td>£{ delegate.price }</td>
                            </tr>
                        );
                    })}
                    <tr>
                        <td><strong styleName="summary__costs-label">Subtotal</strong></td>
                        <td><span styleName="summary__costs-value">&pound;{ this._getSubtotal() }</span></td>
                    </tr>
                    {this.props.promotions.length > 0 && this._getPromotions().map((promotion, index) => {
                        return (
                            <tr key={ index }>
                                <td>
                                    <span className={`${style['summary__costs-label']} ${style['summary__discount']}`}>{ promotion.label }
                                        {promotion.type === 'fixed_percentage' && (<span> ({promotion.discount}% <span styleName="promotion-description--discount">discount</span>)</span>)}
                                        {promotion.type === 'fixed_value' && (<span> (&pound;{parseFloat(promotion.discount).toFixed(2)} <span styleName="promotion-description--discount">discount</span>)</span>)}
                                    </span>
                                </td>
                                <td><span className={`${style['summary__costs-value']} ${style['summary__discount']}`}>-&pound;{ parseFloat(promotion.amount).toFixed(2) }</span></td>
                            </tr>
                        );
                    })}
                    {this._getDelegateDiscountValue() > 0 &&
                        <tr>
                            <td>
                                <span className={`${style['summary__costs-label']} ${style['summary__discount']}`}>Multiple Delegates Discount <span styleName="promotion-description--discount">(10%)</span></span>
                            </td>
                            <td><span className={`${style['summary__costs-value']} ${style['summary__discount']}`}>-&pound;{ this._getDelegateDiscountValue() } </span></td>
                        </tr>
                    }
                    <tr>
                        <td><strong styleName="summary__costs-label">Total (Ex VAT)</strong></td>
                        <td><span styleName="summary__costs-value">&pound;{ this._getTotalExcVAT() }</span></td>
                    </tr>
                    <tr>
                        <td><strong styleName="summary__costs-label">VAT ({vatPercent}%)</strong></td>
                        <td><span styleName="summary__costs-value">&pound;{ this._getTotalVAT() }</span></td>
                    </tr>
                    <tr>
                        <td><span className={`${style['summary__label']} ${style['summary__costs-total-label']}`}>Total</span></td>
                        <td><span styleName="summary__costs-total-value">&pound;{ this._getTotal() }</span></td>
                    </tr>
                    </tbody>
                </table>

            </article>
        );
    }
}

export default CSSModules(OrderSummary, style);


// WEBPACK FOOTER //
// ./components/OrderSummary/index.js